import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from '~/contexts/AuthContext/AuthProvider';
import { getMarketBasedOnHostname } from '~/helpers/utils';
import { RootState } from '~/store';

const useLogout = () => {
  const { logout } = useAuth();
  const { language: selectedLanguage, market } = useSelector(
    (state: RootState) => state.intl
  );

  return useCallback(() => {
    localStorage.setItem('qredMarket', market);
    localStorage.setItem('qredLoginLanguage', selectedLanguage);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('qredLanguage');
    posthog.reset();
    posthog.setPersonProperties({
      language: selectedLanguage,
    });
    Sentry.setUser(null);

    // DEPRECATED, see https://qredab.atlassian.net/browse/OB-3841: use the market group instead of person properties
    posthog.setPersonProperties({
      market: getMarketBasedOnHostname() ?? 'unknown',
    });

    logout();
  }, [selectedLanguage, market, logout]);
};

export default useLogout;
